import {IActionBase} from "./IActionBase";

import React, {Component} from "react";

import {ActionsManager} from "./actionsManager";
import {dataUtils} from "../js/dataUtils";
import {sendApplyooComponentsNotification} from "../infrastructure/useApplyooComponent";


export class action_AP_ExecuteElementCommand extends Component implements IActionBase {

    actionCode = "action_AP_ExecuteElementCommand";
    actionName = "Execute Element Command";
    newKeyNumber = -1;

    Execute = (prmActionParameters?:any, prmActionsManager?:ActionsManager, prmElementObj?:any, prmData?:any)=> {

        let elementObj = dataUtils.getElementByClientID(prmActionParameters.ElementIdentifier);

        if (!!elementObj) {
            sendApplyooComponentsNotification(elementObj.ElementGuid,
                "",
            { command: prmActionParameters?.ElementSelectedCommand, ...prmActionParameters})

        }
    }

}
